export const editableValidatorMixin = {
  data () {
    return {
      error: null
    }
  },
  props: {
    formValidator: {
      required: true
    },
    tabView: {
      type: String,
      required: true
    },
    validateAlias: {
      type: String,
      default: null
    },
    required: {
      type: Boolean
    }
  },
  created () {
    this.getValidator().subscribeInput(this)
  },
  destroyed () {
    this.getValidator().unsubscribeInput(this)
  },
  computed: {
    getError () {
      if (!this.error) {
        return false
      }
      return this.error
    }
  },
  methods: {
    getElement () {
      return this.getTableRef()
    },
    getTableRef () {
      throw Error('Define getTableRef() method wich return this.$refs.name')
    },
    getValidator () {
      return this.formValidator
    },
    validate () {
      let msg = ''
      let data = []
      if (this.getTableRef()) {
        data = this.getTableRef().getData()
      }

      if (this.required && data.length === 0) {
        msg = 'Добавьте минимум одну запись'
      }

      if (!msg) {
        for (let i = 0; i < data.length; i++) {
          let r = data[i]
          if (this.getTableRef().isEdit(r)) {
            msg = 'В таблице есть несохраненные записи - сохраните либо удалите их'
            break
          }
        }
      }

      if (!msg) {
        for (let i = 0; i < data.length; i++) {
          let row = data[i]
          if (!this.getTableRef().validateRow(row)) {
            msg = 'В таблице есть заполненые неверно записи'
            this.getTableRef().openEditMode(row)
            break
          }
        }
      }

      // debugger

      return {
        error: msg,
        tabView: this.tabView,
        name: this.validateAlias,
        modalVariableName: null,
        el: null
      }
    }
  }
}
